module.exports = __webpack_public_path__ + "static/img/s01.1ad30790.png";